import React, { useMemo } from 'react';
import { RadioOption } from 'components/RadioGroupField/RadioGroupField.component';
import { useTranslation } from 'react-i18next';
import {
  INCLUDE_VIDEO_IN_TEASER,
  IncludeVideoInTeaser,
  TEASER_TYPE,
  TEASER_VERIFICATION,
  TeaserType,
  TeaserVerification,
} from 'models/Listing';
import { Link } from 'react-router-dom';
import LinkToIcon from 'icons/LinkTo.icon';

export function useGenerateSliderOptions(previewTeaserLink: string) {
  const { t } = useTranslation();

  const teaserTypeOptions = useMemo<RadioOption<TeaserType>[]>(
    () => [
      {
        label: (
          <>
            {t('resolveDigitalTeaser')}
            <Link className="lcw-enable-teaser__link" to={previewTeaserLink}>
              {t('previewTeaser')}
              <LinkToIcon />
            </Link>
          </>
        ),
        value: TEASER_TYPE.RESOLVE_DIGITAL_TEASER,
      },
      { label: t('uploadTeaserFile'), value: TEASER_TYPE.OWN_TEASER_FILE },
    ],
    [previewTeaserLink, t],
  );

  const verifyBuyersOptions = useMemo<RadioOption<TeaserVerification>[]>(
    () => [
      {
        label: (
          <>
            {t('withoutVerification')}
            <span className="recommended">{t('recomended')}</span>
          </>
        ),
        value: TEASER_VERIFICATION.WITHOUT_EMAIL_VERIFICATION,
      },
      {
        label: t('afterTheyVerify'),
        value: TEASER_VERIFICATION.WITH_EMAIL_VERIFICATION,
      },
    ],
    [t],
  );

  const includeVideoOptions = useMemo<RadioOption<IncludeVideoInTeaser>[]>(
    () => [
      { label: t('no'), value: INCLUDE_VIDEO_IN_TEASER.NO },
      {
        label: t('yesEmbedVideo'),
        value: INCLUDE_VIDEO_IN_TEASER.WITH_EMBEDDED_CODE,
      },
      {
        label: t('yesVideoFile'),
        value: INCLUDE_VIDEO_IN_TEASER.WITH_VIDEO_FILE,
      },
    ],
    [t],
  );

  return {
    teaserTypeOptions,
    verifyBuyersOptions,
    includeVideoOptions,
  };
}
